import styled from 'styled-components';

import * as MUIIcon from '@mui/icons-material';

export const ShowPasswordIcon = styled(MUIIcon.Visibility)``;

export const HidePasswordIcon = styled(MUIIcon.VisibilityOff)``;
